module.exports = __webpack_public_path__ + "static/img/member24.7de2825.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/member24.jpg
// module id = qDGr
// module chunks = 0